'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';
type NonceContextType = string | undefined;
const NonceContext = createContext<NonceContextType>(undefined);
type NonceProviderProps = {
  children: ReactNode;
  nonce?: string;
};
export const NonceProvider = t0 => {
  const $ = _c(6);
  const {
    children,
    nonce: serverNonce
  } = t0;
  const [nonce, setNonce] = useState(serverNonce);
  let t1;
  let t2;
  if ($[0] !== nonce) {
    t1 = () => {
      if (!nonce) {
        const metaNonce = document.querySelector("meta[name=\"csp-nonce\"]")?.getAttribute("content");
        if (metaNonce) {
          setNonce(metaNonce);
        }
      }
    };
    t2 = [nonce];
    $[0] = nonce;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children || $[4] !== nonce) {
    t3 = <NonceContext.Provider value={nonce}>{children}</NonceContext.Provider>;
    $[3] = children;
    $[4] = nonce;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const useNonce = () => {
  return useContext(NonceContext);
};